import { Component, OnInit } from '@angular/core';
import { VoiceRecognitionService } from '../service/voice-recognition.service'
import { FormGroup, FormControl } from '@angular/forms';


@Component({
  selector: 'app-texttrans',
  templateUrl: './texttrans.component.html',
  styleUrls: ['./texttrans.component.scss']
})
export class TexttransComponent implements OnInit {
  text: any;
  div1: any;
  tcode:any;
  formdata: any;
  message:any;
  constructor() { }

  ngOnInit(): void {
    // this.formdata = new FormGroup({
    //   text: new FormControl(""),
    // });
  }
  submit() {
    console.log("the code :" + this.tcode);
    this.text=this.tcode;
    this.myimg();
   // this.router.navigate(["study"],navigationExtras);
}
  // onClickSubmit(data) { 
  //   this.text = data.message;
  //   if (data.valid) {
  //     console.log("Form Submitted!");
  //   } 
  // }

  myimg() {
    this.div1 = document.getElementById("output");
    this.text.split(' ').forEach(element => {
      let html = `
        <div class="row">
            <h1>${element}</h1>
    `;
      this.div1.insertAdjacentHTML('beforeend', '');
      //height="250px" style="left:0px;padding:0vh 0vw 0vh 1vw;"

      for (let i = 0; i < element.length; i++) {
        const character = element.charAt(i);
        let src;
        if (character.toLowerCase() != character.toUpperCase()) {
          src = `<img src="../../assets/Alphabets/${character.toLowerCase()}.png" height="300px"style="height:300px;padding-right:10px;" alt="${character}">`
        } else {
          src = `<img src="../../assets/Alphabets/default.png" alt="${character}">`
        }
        html += '<span class="item">' + src + '</span>';
      }
      html += '</div>';

      this.div1.insertAdjacentHTML('beforeend', html);
      // $('#output').append(html);
    });


  }
}
